/**
 * The Settings tabs and their URL hashes. The hash is the only state: `#keys` still opens Agent keys
 * because loop detail and the /app/connect redirect link there, and no hash means Workspace.
 */

export type SettingsTab = "workspace" | "keys" | "cards" | "tags" | "policies";

export const SETTINGS_TABS: ReadonlyArray<{ id: SettingsTab; label: string }> = [
  { id: "workspace", label: "Workspace" },
  { id: "keys", label: "Agent keys" },
  { id: "cards", label: "Public cards" },
  { id: "tags", label: "Tags" },
  { id: "policies", label: "Policies" },
];

const DEFAULT_TAB: SettingsTab = "workspace";

export function settingsTabFromHash(hash: string | null | undefined): SettingsTab {
  const key = (hash ?? "").replace(/^#/u, "").trim().toLowerCase();
  const tab = SETTINGS_TABS.find((candidate) => candidate.id === key);
  return tab ? tab.id : DEFAULT_TAB;
}

export function settingsTabHash(tab: SettingsTab): string {
  return tab === DEFAULT_TAB ? "" : `#${tab}`;
}
